import { IconName } from '@televet/kibble-ui';
import { TaskType } from 'shared/types/graphql';
import { TaskGroup } from '../types';

// filters
export const ASSIGNED_TO_ME = 'assignedToMe';
export const COMPLETED_BY_ME = 'completedByMe';
export const UNASSIGNED = 'unassigned';

export const taskGroupsMap: { [key: string]: TaskGroup } = {
  needsAttention: {
    tabIndex: 0,
    name: 'needsAttention',
  },
  completed: {
    tabIndex: 1,
    name: 'completed',
  },
};

export const taskIconByType: Partial<{ [key in TaskType]: IconName }> = {
  [TaskType.Automation]: 'robot',
};
